import Vue from 'vue';
import store from '@/app/app-state';

const numberFormat = (value: number | string) => {
  const locale = store.getters.appLocale || 'en-US';

  const number = Number(value);

  if (isNaN(number)) {
    return value;
  }

  return new Intl.NumberFormat(locale).format(number);
}

Vue.filter('localeNumberFormat', (value: string | number) => {  
  return numberFormat(value);
});

Vue.filter('localeNumberWithCurrencyFormat', (value: string) => {
  let result = value.replace(/,/g, '')
  const numbers = result.split(/\D/g).filter(e => e !== '');

  numbers.forEach((e) => {
    result = result.replace(e, String(numberFormat(e)))
  });

  return result;


  // AED 1,500,000 - 2,000,000+
  // AED 1500000 - 2000000+
  // return result.replace(numbers[0], 'zxc');
  // const currency = value.replace(/[^a-zA-Z]+/g, '');
  // result = value.replace(/\D/g, "");

  // if (value) {
  //   result = Number(result);
  //   console.log('RESULT', new Intl.NumberFormat(locale, { style: 'currency', currency }).format(result));
  //   return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(result);
  // }
});
